import http from "plugins/axios";

export default {
  getSpotAssetsList(data) {
    return http.get({
      url: "/ta/admin/channel/tiger/spot/list",
      data,
    });
  },
  getSpotAssetsTotal(data) {
    return http.get({
      url: "/ta/admin/channel/tiger/spot/total",
      data,
    });
  },
  getSpotCoinList() {
    return http.get({
      url: "/ta/admin/tenant/coin/list",
      data: { type: "SPOT" },
    });
  },
};
